import { useEffect, useState } from 'react';
import { Box, Typography, Paper, Stack, Button, Table, TableHead, TableRow, TableCell, TableBody, Chip, Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { api } from '../services/api';

export default function RolesPage() {
  const [roles, setRoles] = useState([]);
  const [perms, setPerms] = useState([]);
  const [open, setOpen] = useState(false);

  const load = async () => {
    const [a, b] = await Promise.all([api.get('/api/roles'), api.get('/api/roles/permissions')]);
    setRoles(a.data); setPerms(b.data);
  };
  useEffect(() => { load(); }, []);

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4">Roles</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpen(true)}>Add Role</Button>
      </Stack>
      <Paper>
        <Table>
          <TableHead><TableRow><TableCell>Name</TableCell><TableCell>Description</TableCell><TableCell>Permissions</TableCell><TableCell>Type</TableCell></TableRow></TableHead>
          <TableBody>
            {roles.map(r => (
              <TableRow key={r.id}>
                <TableCell>{r.name}</TableCell>
                <TableCell>{r.description || ''}</TableCell>
                <TableCell>{(r.permissionCodes || []).length}</TableCell>
                <TableCell>{r.isSystem ? <Chip size="small" label="System" /> : <Chip size="small" label="Custom" color="primary" />}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
      <RoleDialog open={open} onClose={() => setOpen(false)} onSaved={() => { setOpen(false); load(); }} perms={perms} />
    </Box>
  );
}

function RoleDialog({ open, onClose, onSaved, perms }) {
  const [f, setF] = useState({ name: '', description: '', permissionIds: [] });
  const grouped = perms.reduce((acc, p) => { (acc[p.category || 'General'] ||= []).push(p); return acc; }, {});
  const toggle = (id) => setF(s => ({ ...s, permissionIds: s.permissionIds.includes(id) ? s.permissionIds.filter(x => x !== id) : [...s.permissionIds, id] }));
  const submit = async () => { await api.post('/api/roles', f); onSaved(); };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>New role</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <TextField label="Name" required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
          <TextField label="Description" value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} />
          {Object.entries(grouped).map(([cat, list]) => (
            <Box key={cat}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>{cat}</Typography>
              <FormGroup>
                {list.map(p => <FormControlLabel key={p.id} control={<Checkbox checked={f.permissionIds.includes(p.id)} onChange={() => toggle(p.id)} />} label={`${p.name} (${p.code})`} />)}
              </FormGroup>
            </Box>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={submit} disabled={!f.name}>Create</Button>
      </DialogActions>
    </Dialog>
  );
}
